
import ListItem from "../../../../components/ListItem";


const SystemTypesList = () => {
    return (
        <div className="SystemTypes">
            <h2>System Types List</h2>
            <ListItem endpoint="system_types"/>
        </div>
    );
};
export default SystemTypesList;
